import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { PermisosAutomatizadosService } from 'src/app/services/permisos-automatizados.service';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { decrypt } from 'src/app/utils/constants';

export class TodoItemNode {
  children: TodoItemNode[];
  item: string;
  urlIdPermission: any;
  idPermission: number;
  idUdn: number;
  idPermissionModule: number;
  childs: any;
  permissionData: string
}

export class TodoItemFlatNode {
  item: string;
  level: number;
  icon: number;
  idUdn: number;
  expandable: boolean;
  idPermissionModule: any;
  idPermission: number;
  childs: any;
  permissionData: any
}

@Component({
  selector: 'app-tree-view',
  templateUrl: './tree-view.component.html',
  styleUrls: ['./tree-view.component.scss']
})
export class TreeViewComponent implements OnInit {
  @Output() selectedPermissions = new EventEmitter<any>();
  @Output() userPermissions = new EventEmitter<any>();
  @Output() iconAvailableList = new EventEmitter<any>();
  @Output() moduleListService = new EventEmitter<any>();
  @Output() urlExcel = new EventEmitter<string>();
  @Input() onEditingProfile: number;

  flatNodeMap = new Map<TodoItemFlatNode, TodoItemNode>();
  nestedNodeMap = new Map<TodoItemNode, TodoItemFlatNode>();
  selectedParent: TodoItemFlatNode | null = null;
  userData = JSON.parse(localStorage.getItem("usuario"));
  modulesList: any = [];
  modulesArray: any = [];
  dataSourceTree: any = []
  permissionsAdded: any = []
  permissionsIcons: any = []
  functionsOnEdit: any = [];
  functionsDefault: any = [];
  iconList: any = [];
  standartImage: any = `https://s3.amazonaws.com/${environment.AWS_CONFIG.credentials.structureBucket}/iconos-home/generico.png`
  baseUrlPath: any = `https://s3.amazonaws.com/${environment.AWS_CONFIG.credentials.structureBucket}/iconos-home`
  counter = 0
  onInitCounterModule: number = 0

  // sources
  treeControl: FlatTreeControl<TodoItemFlatNode>;
  treeFlattener: MatTreeFlattener<TodoItemNode, TodoItemFlatNode>;
  dataSource: MatTreeFlatDataSource<TodoItemNode, TodoItemFlatNode>;
  dataSourceBackup: any [];
  filteredData: any [];
  destructuredData: any [];

  // checked
  checklistSelection = new SelectionModel<TodoItemFlatNode>(true /* multiple */);
  previousChecklistSelection: SelectionModel<TodoItemFlatNode>;

  constructor(
    private ngxService: NgxUiLoaderService,
    private permisosAutomatizados: PermisosAutomatizadosService) {
      this.treeFlattener = new MatTreeFlattener(
        this.transformer, this.getLevel, this.isExpandable, this.getChildren
      );
      this.treeControl = new FlatTreeControl<TodoItemFlatNode>(this.getLevel, this.isExpandable);
      this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
      this.previousChecklistSelection = this.checklistSelection;
  }

  async ngOnInit() {
    await this.initDataSource();
    console.log('ID PERFIL =>', this.onEditingProfile)
    
    if (this.onEditingProfile != null ) { 
      this.getProfilePermission(this.onEditingProfile) 
      this.onInitCounterModule++
    }

    else {
    //DISABLE MODULES BY DEFAULT
    setTimeout(() => {
      this.functionsDefault.modules = this.treeControl.dataNodes
        .filter(node => node.idUdn === 44)
        .map(node => node.idPermission);

      this.functionsDefault.functions = [];
      this.restoreDefaultTreeValues();
      this.onInitCounterModule++
      }, 700);
    }
    this.ngxService.stop();
  }

  async initDataSource() {
    this.ngxService.start();
    try {
      const result: any = await this.permisosAutomatizados.getModules(this.userData.idCliente);
      const decoded: any = await decrypt({ data: result.data });
      let response: any = decoded.data

      if(response.code === 200) {
        if(response.items && response.items.length > 0) {

          for (let i = 0; i < response.items.length; i++) {
            let listIndex = response.items[i]?.list;
            this.modulesList = this.modulesList.concat(listIndex);
          }
          const result = this.buildFileTree(this.modulesList, 0);          
          
          //Ordenar datos ABC 
          result.sort((a, b) => {

            //(Nodos hijos)
            if(a.childs.length > 0) {
              a.children.sort((a, b) => a.item.localeCompare(b.item));
            }

            //(Nodos padres)
            const nameA = a.item.toUpperCase(); // ignore upper and lowercase
            const nameB = b.item.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
          
            // names must be equal
            return 0;
          });

          this.dataSource.data = result
          this.dataSourceBackup = result

          //Listado sin hijos para filtro de busqueda
          let list = [];
          result.forEach(module => {
            list = list.concat(this.flattenPermissions(module));
          });

          this.destructuredData = list;
          this.moduleListService.emit(list);
        }
        else {
          this.ngxService.stop();
          return this.showAlert(
            'Información', 
            `No se encontraron módulos disponibles para mostrar.`
          )
        }
      }
      else {
        this.ngxService.stop();
        return this.showAlert(
          'Algo salió mal', 
          `Espere unos segundos y vuelva a intentar por favor.`
        )
      }

    } catch(err) {
      console.log(err);
      this.ngxService.stop();
      return this.showAlert(
        'Error al cargar modulos', 
        `Lo sentimos, hubo un problema en el servicio, favor de volver a intentar.`
      )
    }
  }

  flattenPermissions(node, list = []) {
    list.push(node);

    if (node.children && node.children.length > 0) {
      node.children.forEach(children => this.flattenPermissions(children, list));
    }

    return list;
  }

  buildTreeData(obj: any) {
    Object.keys(obj).forEach(key => {
      const value = obj[key];
      this.dataSourceTree.push({item: value.name, children: value.childs})
    });
  }

  async getProfilePermission(idPerfil: number) {
    this.ngxService.start();
    try {
      setTimeout(async () => {
        const result: any = await this.permisosAutomatizados.getProfilePermission(idPerfil);
        const decoded: any = await decrypt({ data: result.data });
        let response: any = decoded.data
        
        
        if( response.code === 200 ) { 
          this.functionsOnEdit = decoded.data.items[0]
          this.urlExcel.emit(this.functionsOnEdit.url);

          if(this.functionsOnEdit.modules[0]) {
            this.restoreTreeValues()
          }
          else {
            this.userPermissions.emit(null);
          }
        }
        else {
          this.ngxService.stop();
          return this.showAlert(
            'Algo salió mal', 
            `Espere unos segundos y vuelva a intentar por favor.`
          )
        }
        this.ngxService.stop();
      }, 700);

    } catch(err) {
      console.log(err);
      this.ngxService.stop();
      return this.showAlert(
        'Error al obtener información', 
        `Lo sentimos, hubo un problema en el servicio, favor de volver a intentar.`
      )
    }
  }

  restoreTreeValues() {
    this.permissionsAdded = []
    this.permissionsIcons = []

    this.functionsOnEdit.modules.forEach(id => {
      this.findNodeAndSelect(this.modulesList, id);
    });

    //OBTIENE DIFERENCIAS ENTRE this.permissions & this.functionsOnEdit.modules
    let aux: any = [...this.treeControl.dataNodes]
    let difference: any = this.permissionsAdded.filter(x => this.functionsOnEdit.modules.indexOf(x) === -1);

    if(difference[0]){
      //QUITAR CHECK CASILLAS ENCONTRADAS
      for (let i = 0; i < difference.length; i++) {
        aux.forEach(pos => {
          if(difference[i] == pos.idPermissionModule){
            this.checklistSelection.deselect(pos);
          }
        });
      }
    }
    this.permissionsAdded = this.functionsOnEdit.modules;
    this.userPermissions.emit(this.functionsOnEdit);
    this.selectedPermissions.emit(this.functionsOnEdit.modules)
  }

findNodeAndSelect(list: any[], id: number) {
  for (const element of list) {

    if (element.idPermissionModule == id) {

      const flatNode = this.treeControl.dataNodes.find(
        n => n.idPermissionModule == id
      );

      if (flatNode) {
        this.checklistSelection.select(flatNode);
        this.treeControl.expand(flatNode);
        this.checkAllParentsSelection(flatNode); 
      }
    }

    if (element.childs?.length) {
      this.findNodeAndSelect(element.childs, id);
    }
  }
}

  restoreDefaultTreeValues() {
    for (let i = 0; i < this.functionsDefault.modules.length; i++) {
      this.modulesList.forEach(element => {
        
        //BUSQUEDA POR ID
        if(element.idPermission == this.functionsDefault.modules[i]){
          
          //BUSQUEDA POR NOMBRE ITEM
          for (let i = 0; i < this.treeControl.dataNodes.length; i++) {
            if (this.treeControl.dataNodes[i].item == element.name) {
              this.todoItemSelectionToggle(this.treeControl.dataNodes[i]);
            }
          }
        }
      });
    }
    this.userPermissions.emit(this.functionsDefault);
    this.deselectDefaultItems()
  }

  showAlert(title:string ,message:string){
    Swal.fire({
      title: title,
      icon:  'info',
      text:  message,
      confirmButtonColor: '#545D6E',
      confirmButtonText: '<span style="color: #ffffff"> Entendido </span>',
    })
  }

  buildFileTree(obj: object, level: number): TodoItemNode[] {
    if (!obj) { return []; }
    
    return Object.keys(obj).sort().reduce<TodoItemNode[]>((accumulator, key) => {
      const value = obj[key];
      const node = new TodoItemNode();
      node.item = value.name;
      node.urlIdPermission = this.baseUrlPath + '/' + value.idPermission + '.png';
      node.idPermission = value.idPermission;
      node.idUdn = value.idUdn;
      node.idPermissionModule = value.idPermissionModule;
      node.childs = value['childs'];
      node.permissionData = value.idPermission + ' - ' + value.name;

      if (value.childs != null) {
        if (value.childs.length > 0) {
          node.children = this.buildFileTree(value.childs, level + 1);
        } else {
          node.item = value.name;
        }
      }
      return accumulator.concat(node);
    }, []);
  }

  getLevel = (node: TodoItemFlatNode) => node.level;

  getIcon = (node: TodoItemFlatNode) => node.icon;

  isExpandable = (node: TodoItemFlatNode) => node.expandable;

  getChildren = (node: TodoItemNode): TodoItemNode[] => node.children;

  hasChild = (_: number, nodeData: TodoItemFlatNode) => nodeData.expandable;

  hasNoContent = (_: number, nodeData: TodoItemFlatNode) => nodeData.item === '';

  transformer = (node: TodoItemNode, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode = existingNode && existingNode.item === node.item
      ? existingNode
      : new TodoItemFlatNode();
    
    flatNode.item = node.item;
    flatNode.level = level;
    flatNode.icon = node.urlIdPermission;
    flatNode.idUdn = node.idUdn;
    flatNode.idPermissionModule = node.idPermissionModule;
    flatNode.idPermission = node.idPermission;
    flatNode.childs = node.childs;
    flatNode.permissionData = node.idPermission + ' - ' + node.item;
    flatNode.expandable = !!node.children && node.children.length > 0;
    
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
  }

  handleMissingImage(event: any) {    
    for (let i = 0; i < this.treeControl.dataNodes.length; i++) {
      if (event.idPermissionModule === this.treeControl.dataNodes[i].idPermissionModule) {
        this.treeControl.dataNodes[i].icon = this.standartImage
      }
    }
  }

  checkAll() {
    for (let i = 0; i < this.treeControl.dataNodes.length; i++) {
      if (!this.checklistSelection.isSelected(this.treeControl.dataNodes[i])) {
        this.checklistSelection.toggle(this.treeControl.dataNodes[i]);
      }
      this.treeControl.expand(this.treeControl.dataNodes[i]);
    }
  }

  descendantsAllSelected(node: TodoItemFlatNode): boolean {
    if (!this.treeControl.dataNodes || !node) return false; 

    const descendants = this.treeControl.getDescendants(node);
    if (!descendants || descendants.length === 0) {
      return this.checklistSelection.isSelected(node);
    }

    return descendants.every(child =>
      this.checklistSelection.isSelected(child)
    );
  }

  /** Whether part of the descendants are selected */
  descendantsPartiallySelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some(child => this.checklistSelection.isSelected(child));
    return result && !this.descendantsAllSelected(node);
  }

  /** Toggle the to-do item selection. Select/deselect all the descendants node */
  todoItemSelectionToggle(node: TodoItemFlatNode): void {
    this.findIdPermission(node);
    this.checklistSelection.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);

    // Force update for the parent
    descendants.every(child =>
      this.checklistSelection.isSelected(child)
    );
    this.checkAllParentsSelection(node);
  }

  deselectDefaultList(node: TodoItemFlatNode): void {
    this.checklistSelection.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);

    // Force update for the parent
    descendants.every(child =>
      this.checklistSelection.isSelected(child)
    );
    this.checkAllParentsSelection(node);
  }

  todoLeafItemSelectionToggle(node: TodoItemFlatNode): void {
    this.findIdPermission(node);
    this.checklistSelection.toggle(node);
    this.checkAllParentsSelection(node);

    /* Sort data */
    this.functionsOnEdit.modules.sort(function (a, b) {
      return a - b;
    });
    /* delete duplicates */
    const removeDuplicates = function(nums) {
      for (let i = nums.length - 1; i >= 0; i--) {
        for (let j = 0; j < i; j++)
          if (nums[j] === nums[i]) {
            nums.splice(i, 1);
            break;
          }
      }
    };
    removeDuplicates(this.functionsOnEdit.modules);
  }

  findIdPermission(item: any) {
    let isSelected: boolean = this.checklistSelection.isSelected(item);

    if( this.functionsDefault.modules != null && this.counter === 0 ) {
      this.counter ++
      setTimeout(() => {
        this.permissionsIcons = this.functionsDefault.modules
        this.showActiveIcons() //ICONOS ACTIVOS
        this.selectedPermissions.emit(this.permissionsAdded)
        this.functionsDefault.modules = null  
      }, 500);
    } 

    // AGREGAR PERMISO
    if (!isSelected) {
      this.addItemAndChilds(item);
      this.addParentsToSelection(item);
    }

    // QUITAR PERMISO
    if (isSelected) {
      this.removeItemAndChilds(item);
    }

    this.showActiveIcons();
    this.selectedPermissions.emit(this.permissionsAdded);
  }

  addParentsToSelection(node: TodoItemFlatNode) {
    let parent = this.getParentNode(node);
    while (parent) {
      if (!this.permissionsAdded.includes(parent.idPermissionModule)) {
        this.permissionsAdded.push(parent.idPermissionModule);
        this.permissionsIcons.push(parent.idPermission);
      }
      parent = this.getParentNode(parent);
    }
  }

  addItemAndChilds(item: any) {
    if ( this.onInitCounterModule === 0 ) { //Al iniciar ngOnInit
      if( item.idUdn === 44 ) {
        this.permissionsAdded.push(item.idPermissionModule);
        this.permissionsIcons.push(item.idPermission);
      }
    }
    else {
      this.permissionsAdded.push(item.idPermissionModule);
      this.permissionsIcons.push(item.idPermission);
    }

    if ( item.childs?.length ) {
      item.childs.forEach( child => this.addItemAndChilds(child) )
    }
  }

  removeItemAndChilds(item: any) {
    this.permissionsAdded = this.permissionsAdded.filter(id => id !== item.idPermissionModule);
    this.permissionsIcons = this.permissionsIcons.filter(id => id !== item.idPermission);

    if (item.childs?.length) {
      item.childs.forEach( child => this.removeItemAndChilds(child) )
    }
  }

  showActiveIcons() {
    let arrayIcons = [];
    
    for (let i = 0; i < this.permissionsIcons.length; i++) {
      this.iconList.forEach(element => {
        //BUSQUEDA POR ID
        if(element.idPermission === this.permissionsIcons[i]) {
          //AGREGA ELEMENTO ENCONTRADO
          arrayIcons.push({name: element.name, url: element.url, idPermission: element.idPermission})
        }
      });
    }
    //Ordenar datos ABC 
    arrayIcons.sort((a, b) => {
      const nameA = a.name.toUpperCase(); // ignore upper and lowercase
      const nameB = b.name.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
    
      // names must be equal
      return 0;
    });
    const noDuplicates = this.deleteDuplicatesIcons(arrayIcons)
    this.iconAvailableList.emit(noDuplicates);
  }

  deleteDuplicatesIcons(iconos: any) {
    function removeDuplicates(elements) {
      let cleaned = []
      elements.forEach(element => {
        let encoded_value = JSON.stringify(element)
        if(cleaned.includes(encoded_value)){
          let position = cleaned.indexOf(encoded_value)
          cleaned.splice(position, 1)
        }else{
          cleaned.push(encoded_value)
        }
      })
      return cleaned.map(element => {
        return JSON.parse(element)
      })
    }
    return removeDuplicates(iconos)
  }

  deselectDefaultItems(){
    // ENCUENTRA PERMISOS SELECCIONADOS DEFAULT LEVEL 1 != idUdn 44
    let deselectList: any = []

    for (let i = 0; i < this.modulesList.length; i++) {
      if(this.modulesList[i].childs[0]){
        this.modulesList[i].childs.forEach(position => {
          if(position.idUdn != 44){
            deselectList.push(position.idPermissionModule)
          }
        });
      }
    }
    this.filterPermissionList(deselectList);
  }

  filterPermissionList(list: any) {
    //QUITA PERMISOS SELECCIONADOS != idUdn 44 DE ARRAY this.permissions
    if(list.length > 0 && this.onEditingProfile == null){
      for (let z = 0; z < list.length; z++) {
        let dataUpdate = this.permissionsAdded.filter( value => value != list[z]);
        this.permissionsAdded = dataUpdate;
      }
    }
    //DESELECCIONAR CASILLAS CHILDS != idUdn 44
    for (let i = 0; i < this.treeControl.dataNodes.length; i++) {
      if(this.treeControl.dataNodes[i].idUdn != 44){
        this.checklistSelection.deselect(this.treeControl.dataNodes[i]);
      }
    }
    this.selectedPermissions.emit(this.permissionsAdded)
  }

  /* Checks all the parents when a leaf node is selected/unselected */
  checkAllParentsSelection(node: TodoItemFlatNode): void {
    let parent: TodoItemFlatNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }

  /** Check root node checked state and change it accordingly */
  checkRootNodeSelection(node: TodoItemFlatNode): void {
    const nodeSelected = this.checklistSelection.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.every(child =>
      this.checklistSelection.isSelected(child)
    );
    if (nodeSelected && !descAllSelected) {
      this.checklistSelection.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelection.select(node);
    }
  }

  /* Get the parent node of a node */
  getParentNode(node: TodoItemFlatNode): TodoItemFlatNode | null {
    const currentLevel = this.getLevel(node);
    if (currentLevel < 1) { return null; }

    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (this.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }

  /* filterByModule(textKey: any) {
    const filterValue = (textKey.target as HTMLInputElement).value;
    console.log(this.destructuredData)
    
    if (filterValue == '') {
      this.dataSource.data = this.dataSourceBackup;
    } 
    else {
      this.filteredData = this.destructuredData.filter(datum => ( 
        datum.permissionData.toLowerCase().indexOf(filterValue.toLowerCase()) > -1)
      );

      this.dataSource.data = this.filteredData;
    }
  }  */

  filterByModule(textKey: any) {
    const filterValue = (textKey.target as HTMLInputElement).value.toLowerCase();
    
    if (filterValue === '') {
      this.dataSource.data = this.dataSourceBackup;
      return;
    }

    const childKeys = new Set();
    const extractChildKeys = (items: any[]) => {
      items?.forEach(item => {
        const children = item.children || item.childs;
        children?.forEach((c: any) => {
          childKeys.add(`${c.idPermission}-${c.idPermissionModule}`);
          extractChildKeys([c]); // Recursión para niveles profundos
        });
      });
    };
    extractChildKeys(this.destructuredData);

    // Buscar match en el elemento o en sus descendientes
    const checkMatchRecursive = (item: any): boolean => {
      const idStr = (item.idPermission || "").toString();
      const nameStr = (item.permissionData || item.name || item.item || "").toLowerCase();
      
      // ¿El elemento coincide?
      if (nameStr.includes(filterValue) || idStr.includes(filterValue)) {
        return true;
      }
      
      // ¿Alguno de sus hijos/nietos coincide?
      const children = item.children || item.childs;
      if (children && children.length > 0) {
        return children.some((child: any) => checkMatchRecursive(child));
      }
      
      return false;
    };

    this.filteredData = this.destructuredData.filter(datum => {
      const currentKey = `${datum.idPermission}-${datum.idPermissionModule}`;
      
      if (childKeys.has(currentKey)) return false;

      return checkMatchRecursive(datum);
    });

    this.dataSource.data = this.filteredData;

    // 4. Expandimos todo para que el usuario vea el resultado final
    if (this.treeControl) {
      this.treeControl.expandAll();
    }
  }


  updateModulesByExcel(updateList: any, nodoToSelect: any) {
    this.functionsOnEdit.modules = updateList

    this.treeControl.dataNodes.map(node => {
      if(nodoToSelect == node.idPermissionModule) {
        this.todoLeafItemSelectionToggle(node)
      }
    });
  }

}

